import last from 'lodash/last';
import { forwardRef, useMemo } from 'react';
import { FileUploader } from './FileUploader.js';
import { jsx } from '@emotion/react/jsx-runtime';

const SingleFileUploader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value: internalValue,
    onChange: onChangeProp,
    ...props
  } = _ref;
  const value = useMemo(() => internalValue ? [internalValue] : [], [internalValue]);
  const onChange = files => onChangeProp(last(files));
  return jsx(FileUploader, {
    value: value,
    onChange: onChange,
    ref: ref,
    multiple: false,
    ...props
  });
});
SingleFileUploader.displayName = 'SingleFileUploader';

export { SingleFileUploader };
//# sourceMappingURL=SingleFileUploader.js.map
